module.exports = __webpack_public_path__ + "media/images/icons/filled/dropbox-circle-ae3e543dad3bd4c7546229e4c5c4887e.svg";